export default function (obj: { [key: string]: any }): boolean {
  if (!obj) {
    return true;
  }
  for (const key in obj) {
    if (obj[key]) {
      return false;
    }
  }
  return true;
}
